import { render, staticRenderFns } from "./SessionExpiringModal.vue?vue&type=template&id=33e2a879"
import script from "./SessionExpiringModal.vue?vue&type=script&lang=js"
export * from "./SessionExpiringModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports